import React, { useState, useEffect } from "react";
import { connect } from "react-redux";

//ANT DESIGN IMPORTS
import {
  Space,
  Divider,
  Input,
  Row,
  Col,
  Typography,
  Card,
  Select,
  Form,
  Checkbox,
  Spin,
  InputNumber,
} from "antd";
import { useNavigate, useLocation } from "react-router-dom";

//PROJECT IMPORTS
import MainLayout from "../../../components/layouts/MainLayout";
import CustomButton from "../../../components/custom/CustomButton";
import TopContent from "../../../components/layouts/TopContent";
import appStatic from "../../../config/appStatic";
import appLabel from "../../../config/appLabel";
import cnt from "../../../services/definedConstant";
import { BOM } from "../../../services/definedMethod";
import definedApi from "../../../services/definedApi";
import { showCheckerApprovalModal } from "../../../components/CheckerModal";

const { Text, Title } = Typography;

const EditGLA0300 = (props) => {
  //DECLARED VARIABLES
  const { userData } = props;
  const { session } = userData;

  const navigate = useNavigate();
  const { state } = useLocation();
  const { months, revaluations, editFinanceRuleItems, monthList } = appStatic;
  const {
    editFinanceRules,
    finPeriodStart,
    finPeriodEnd,
    finYearEnd,
    localCurrency,
    revaluationOptions,
    comMonthlyGlBalance,
    reportLargeMovement,
    pLAccountProfitGL,
    pLAccountLossGL,
    movementValue,
    pleaseEnter,
  } = appLabel;

  const [useForm] = Form.useForm();
  const [equityData, setEquityData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [localCurrencyData, setLocalCurrencyData] = useState("");
  const [selectedProfitGl, setSelectedProfitGl] = useState("");
  const [selectedLossGl, setSelectedLossGl] = useState("");
  const [financeRuleDetail, setFinanceRuleDetail] = useState([]);
  const [check, setCheck] = useState(true);
  const [checkedLargeMovement, setCheckedLargeMovement] = useState(false);
  const [monthlyAverage, setMonthlyAverage] = useState(false);
  const [selectedStartMonth, setSelectedStartMonth] = useState("");
  const [currencyData, setCurrencyData] = useState([]);

  useEffect(() => {
    // console.log(useForm);
    getLocalCurrency();
    getEquity();
    getDetailById(state);
    getCurrency();
    //ACTIVATE SAVE RIGHTSIDEBAR ACTION
    // dispatch({
    //   type: cnt.RIGHT_SAVE_BTN,
    // });
  }, []);

  function onCancel() {
    navigate("/gla0300", { replace: false });
  }

  const getDetailById = (params) => {
    setIsLoading(true);

    const url = `${definedApi.DetailFinanceRules}/${params.key}`;

    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objDetail = res;
        setFinanceRuleDetail(objDetail);

        // SHOW THE SAVED DATA
        useForm.setFieldsValue({
          period_start_month: objDetail.periodStartMonth, //monthList[objDetail.periodStartMonth - 1],
          period_end_month: objDetail.periodEndMonth, //monthList[objDetail.periodEndMonth - 1],
          financial_year_end_month: objDetail?.financialYearEndMonth, // monthList[objDetail?.financialYearEndMonth - 1],
          auto_revaluation: objDetail?.autoRevaluation,
          localCurrency: objDetail?.localCurrencyCode,
          pl_profit_gl: objDetail?.plProfitGL?.id,
          pl_loss_gl: objDetail?.plLossGL?.id,
          large_movement_threshold: objDetail.largeMovementThreshold,

          // report_large_movement:objDetail.reportLargeMovement,
          // compute_avg_balance:objDetail,
        });
        setCheckedLargeMovement(objDetail?.reportLargeMovement);
        setMonthlyAverage(objDetail?.computeAvgBalance);
        handleSelectedStartMonth(objDetail.periodStartMonth);
        setIsLoading(false);
      }
    });
  };

  function getLocalCurrency() {
    let body = {
      session,
    };

    BOM.FetchReqAction(body, definedApi.GetFRLocalCurrency, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        const objList = res;
        let tempValue = objList;
        console.log(tempValue);
        setLocalCurrencyData(tempValue);
      }
    });
  }

  function getEquity() {
    let body = {
      session,
    };

    BOM.FetchReqAction(body, definedApi.GetFREquity, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        const objList = res;
        let tempEquityData = [];

        objList.forEach((element) => {
          tempEquityData.push({
            value: element.id,
            label: `${element.glCode} (${element.name})`,
            code: element.glCode,
          });
        });

        setEquityData(tempEquityData);
      }
    });
  }

  function getCurrency() {
    let body = {
      session,
    };

    BOM.FetchReqAction(body, definedApi.CurrencyList, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        const objList = res.selectedCurrencyOptions;
        let temp = [];

        console.log(objList);

        objList.forEach((element) => {
          temp.push({
            value: element.code,
            label: element.displayLabel,
          });
        });

        setCurrencyData(temp);
      }
    });
  }

  const handleReportLargeMovement = (keyParam) => {
    setCheckedLargeMovement(keyParam);
  };

  const handleMonthlyAverage = (keyParam) => {
    setMonthlyAverage(keyParam);
  };

  const handleSelectedStartMonth = (keyParam) => {
    setSelectedStartMonth(keyParam);

    console.log(monthList, keyParam);
    if (keyParam !== 1) {
      useForm.setFieldsValue({
        period_end_month: monthList[keyParam - 2],
        financial_year_end_month: monthList[keyParam - 2],
      });
    } else {
      useForm.setFieldsValue({
        period_end_month: monthList[keyParam + 10],
        financial_year_end_month: monthList[keyParam + 10],
      });
    }
  };

  const onSubmit = (formValues) => {
    const url = `${definedApi.EditFinanceRules}/${state.key}`;

    formValues.report_large_movement = checkedLargeMovement;
    formValues.compute_avg_balance = monthlyAverage;
    formValues.local_currency_code = localCurrencyData.code;
    formValues.locale = "en";

    formValues.period_start_month = formValues.period_start_month + "";
    formValues.period_end_month =
      Number(formValues.period_start_month) === 1
        ? 12 + ""
        : formValues.period_start_month - 1 + "";
    formValues.financial_year_end_month =
      Number(formValues.period_start_month) === 1
        ? 12 + ""
        : formValues.period_start_month - 1 + "";
    formValues.allow_period_reversal = true;
    formValues.allow_financial_year_reversal = true;

    const body = {
      ...formValues,
      method: "PUT",
      session,
    };

    // console.log(body);return
    setIsLoading(true);
    BOM.FetchReqAction(
      body,
      url,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, appLabel.editFinanceRuleCreatedMsg);
          navigate("/gla0300");
          //STOP LOAD
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          navigate("/gla0300");
          setIsLoading(false);
        },
      }
    );
  };

  return (
    <MainLayout isEnableRightSidebar={false}>
      <TopContent pageTitle={editFinanceRules} pageItems={editFinanceRuleItems} />
      <Spin spinning={isLoading} size="large">
        <Card
          title={
            <Title level={4} style={{ color: "#000" }}>
              {"Finance Rule Edit"}
            </Title>
          }
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Form form={useForm} layout="vertical" onFinish={onSubmit}>
            <Card
              style={{
                marginBottom: "2%",
                boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
              }}
              bordered
            >
              <Row style={{ justifyContent: "space-between" }}>
                <Divider orientation="left" orientationMargin="0">
                  {appLabel.currencyInfo}
                </Divider>
                <Form.Item
                  name="period_start_month"
                  label={<Text style={{ fontSize: "16px" }}>{finPeriodStart}</Text>}
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(finPeriodStart),
                    },
                  ]}
                >
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(finPeriodStart)}
                    style={{ width: "30vh" }}
                    showSearch
                    options={months}
                    onChange={handleSelectedStartMonth}
                  />
                </Form.Item>
                <Form.Item
                  name="period_end_month"
                  label={<Text style={{ fontSize: "16px" }}>{finPeriodEnd}</Text>}
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(finPeriodEnd),
                    },
                  ]}
                >
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(appLabel.finPeriodEnd)}
                    style={{ width: "30vh", fontWeight: "bold" }}
                    disabled
                    options={months}
                  />
                </Form.Item>
                <Form.Item
                  name="financial_year_end_month"
                  label={<Text style={{ fontSize: "16px" }}>{finYearEnd}</Text>}
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(finYearEnd),
                    },
                  ]}
                >
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(appLabel.finYearEnd)}
                    style={{ width: "30vh", fontWeight: "bold" }}
                    disabled
                    options={months}
                  />
                </Form.Item>
              </Row>

              <Row style={{ justifyContent: "space-between" }}>
                <Divider orientation="left" orientationMargin="0">
                  {appLabel.glAccountOptions}
                </Divider>
                <Col>
                  <Form.Item name="report_large_movement">
                    <Checkbox
                      style={{ width: "30vh" }}
                      onClick={() => setCheck(!check)}
                      onChange={(e) => handleReportLargeMovement(e)}
                      checked={financeRuleDetail.reportLargeMovement}
                    >
                      <Text style={{ fontSize: "16px" }}>{reportLargeMovement}</Text>
                    </Checkbox>
                  </Form.Item>
                  <div hidden={!check}>
                    <Form.Item
                      name="large_movement_threshold"
                      rules={[
                        {
                          required: check,
                          message: BOM.CheckReqFld(movementValue),
                        },
                      ]}
                    >
                      <InputNumber
                        placeholder={BOM.handlePlaceholderMsg(movementValue, pleaseEnter)}
                        style={{ width: "30vh" }}
                        formatter={BOM.FormatAmount}
                        parser={BOM.ParseAmount}
                      />
                    </Form.Item>
                  </div>
                </Col>
                <Col>
                  <Form.Item
                    name="auto_revaluation"
                    label={<Text style={{ fontSize: "16px" }}>{revaluationOptions}</Text>}
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld(revaluationOptions),
                      },
                    ]}
                  >
                    <Select
                      placeholder={BOM.handlePlaceholderMsg(revaluationOptions)}
                      style={{ width: "30vh" }}
                      options={revaluations}
                    />
                  </Form.Item>
                </Col>
                <Form.Item name="compute_avg_balance">
                  <Checkbox style={{ width: "30vh" }} onChange={(e) => handleMonthlyAverage(e)}>
                    <Text style={{ fontSize: "16px" }}>{comMonthlyGlBalance}</Text>
                  </Checkbox>
                </Form.Item>
              </Row>

              <Row justify={"space-between"}>
                <Divider orientation="left" orientationMargin="0">
                  {appLabel.plInfo}
                </Divider>
                <Form.Item
                  // name="local_currency_code"
                  label={<Text style={{ fontSize: "16px" }}>{localCurrency}</Text>}
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(localCurrency),
                    },
                  ]}
                >
                  <Input
                    placeholder={BOM.handlePlaceholderMsg(localCurrency)}
                    style={{ width: "30vh" }}
                    value={localCurrencyData.displayLabel}
                    disabled
                  />
                </Form.Item>
                <Space>
                  <Form.Item
                    name="pl_profit_gl"
                    label={<Text style={{ fontSize: "16px" }}>{pLAccountProfitGL}</Text>}
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld(pLAccountProfitGL),
                      },
                    ]}
                  >
                    <Select
                      placeholder={BOM.handlePlaceholderMsg(pLAccountProfitGL)}
                      style={{ width: "30vh" }}
                      showSearch
                      options={equityData}
                      onChange={setSelectedProfitGl}
                    />
                  </Form.Item>
                  {selectedProfitGl && (
                    <Text strong style={{ marginLeft: "15px", fontSize: "15px" }}>
                      {" "}
                      {equityData.find((item) => item.value === selectedProfitGl)?.code}
                    </Text>
                  )}
                </Space>
                <Space>
                  <Form.Item
                    name="pl_loss_gl"
                    label={<Text style={{ fontSize: "16px" }}>{pLAccountLossGL}</Text>}
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld(pLAccountLossGL),
                      },
                    ]}
                  >
                    <Select
                      placeholder={BOM.handlePlaceholderMsg(pLAccountLossGL)}
                      style={{ width: "30vh" }}
                      showSearch
                      options={equityData}
                      onChange={setSelectedLossGl}
                    />
                  </Form.Item>
                  {selectedLossGl && (
                    <Text strong style={{ marginLeft: "15px", fontSize: "15px" }}>
                      {" "}
                      {equityData.find((item) => item.value === selectedLossGl)?.code}
                    </Text>
                  )}
                </Space>
              </Row>
            </Card>
            <Form.Item>
              <Row>
                <CustomButton
                  content="Submit"
                  style={{
                    width: "10%",
                    marginLeft: "auto",
                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                  }}
                  htmlType="submit"
                  backgroundColor="#15CCAE"
                  colorText="black"
                  hoverBackground="#4FECA0"
                />
                <CustomButton
                  content="Cancel"
                  style={{
                    width: "10%",
                    marginLeft: "1%",
                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                  }}
                  backgroundColor="#fff"
                  colorText="black"
                  hoverBackground="#F5F5F5"
                  onClick={onCancel}
                />
              </Row>
            </Form.Item>
          </Form>
        </Card>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(EditGLA0300);
